// controlers
import { ProductController } from "controllers";

const country = localStorage.getItem('country');
const role = localStorage.getItem('role');


export const saveRepairsReport = async ({ stain, buttonMissing, broken, formData, location }) => {
    const reported = { at: +new Date(), by: role };

    const type = [];
    if (stain) { type.push("stain") };
    if (broken) { type.push("broken") };
    if (buttonMissing) { type.push("button_missing") };

    const payload = { ...formData, type, reported, status: "reported", location };
    await ProductController.setRepairsReport(payload);
}

export const validation = async (barcode) => {
    const product = await ProductController.getBarcode(barcode, country);
    return Boolean(product);
}
